/**
 * 配置
 */
export default {
  REAL_DATA_LENGTH: 10, // 单设备监控页面展示多少s的数据
  UNCONNECT_SECONDS: 300000, // n秒未收到数据则判定断开连接
  UNCONNECT_INTERVAL_SECONDS: 10000, // 间隔n秒重连一次
  AXIOS_TIMEOUT: 300000 // http请求时长限制
};
